var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaypalLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#0c3282",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#788db9",
  d: "m20.7 8.56-.05.25c-.58 2.95-2.54 3.97-5.05 3.97h-1.27a.62.62 0 0 0-.62.52l-.65 4.15-.18 1.17c-.04.2.12.38.32.38h2.26c.27 0 .5-.2.54-.46l.02-.11.43-2.71.03-.15a.54.54 0 0 1 .53-.46h.34c2.2 0 3.91-.89 4.42-3.47.2-1.07.1-1.97-.46-2.6-.17-.2-.37-.35-.62-.48Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#b5c1d9",
  d: "M20.1 8.32a5 5 0 0 0-.57-.13 7 7 0 0 0-1.12-.08H15a.54.54 0 0 0-.54.46l-.73 4.6-.02.13c.05-.3.31-.52.62-.52h1.27c2.51 0 4.47-1.02 5.05-3.97l.04-.25a3 3 0 0 0-.6-.24Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.46 8.57a.54.54 0 0 1 .54-.46h3.4a7 7 0 0 1 1.82.25c.17.05.33.12.47.2.17-1.1 0-1.83-.59-2.5C19.45 5.32 18.28 5 16.78 5h-4.35c-.3 0-.57.22-.61.53L10 17c-.03.23.14.44.37.44h2.69l.67-4.28.73-4.6Z"
})));
export default SvgPaypalLight;